import { compressAndPostImage } from '@/assets/Services/compressorService';
import { get, patch, post, remove, put } from '@/helpers/http';

export function belongsToSomeTrack(id) {
  return get(`/belongsToSomeTrack/${id}`);
}

export function isAnswer(id) {
  return get(`/isAnswer/${id}`);
}

export function getArticleById(id) {
  return get(`/articles/${id}`);
}

export function fetchRelatedArticle(departmentId, params = {}) {
  return get(`/related/${departmentId}`, { ...params });
}

export function fetchNextTrackArticle(trackId, params = {}) {
  return get(`/next/track/article/${trackId}`, { ...params });
}

export function fetchArticles(pagination = {}) {
  return get('/articles', { ...pagination });
}

export function fetchAnalyticsArticles(payload) {
  return get('/analytics/articles', payload);
}

export function fetchUserArticles(id, pagination = {}) {
  return get('/list/user/articles', { user_id: id, ...pagination });
}

export function fetchDepartmentArticles(id, pagination = {}) {
  return get('/list/department/articles', { department_id: id, ...pagination });
}

export function getArticlesQuantityByDepartment(departmentId) {
  return get(`/department/articles/${departmentId}`);
}

export function fetchTrackArticles(id, pagination = {}) {
  return get('/list/track/articles', { track_id: id, ...pagination });
}

export function fetchTagArticles(id, pagination = {}) {
  return get('/list/tag/articles', { tag_id: id, ...pagination });
}

export function searchArticles(searchTerm, pagination = {}) {
  return post('/search/articles', { search: searchTerm, ...pagination });
}

export function saveNewArticle(article) {
  return post('/articles', article);
}

export function updateArticle(article) {
  return put(`/articles/${article.id}`, article);
}

export function updateArticleVisits(article) {
  return put(`/article/visit/${article.id}`, article);
}

export function removeArticle(articleId) {
  return remove(`/articles/${articleId}`);
}

export function uploadGifFiles(file) {
  const data = new FormData();
  data.append('file', file);
  return post('/file/upload', data, { 'Content-Type': 'multipart/form-data' });
}

export function uploadImageFiles(file) {
  return compressAndPostImage(file, '/file/upload/');
}

export function getUserArticleRating(id) {
  return get(`/rating/article/${id}`);
}

export function markArticleAsReaded(id) {
  return patch(`/article/read/${id}`);
}

export function saveArticleRating(rating) {
  return post('/ratings', rating);
}
